import { ITemplateFormData } from '../models';

export function isCategoryFormValid(data: Partial<ITemplateFormData>) {
	return data.categoryServices && Object.keys(data.categoryServices).length;
}
